import gql from 'graphql-tag';
export const loginMutation = gql `
  mutation login($record: LoginRecord!) {
    login(record: $record) {
      accessToken
      userDeviceToken
    }
  }
`;
//# sourceMappingURL=login.js.map